import type { Icon } from '@passkeys/modal';

export type ConfirmRequestData = {
  title: string;
  message: string;
  acceptText: string;
};

export type NotifyRequestData = {
  title: string;
  message: string;
  icon: Icon;
};

export const RETRY_OPEN_MESSAGE = {
  title: 'Open popup',
  message:
    'It looks like your browser has blocked the Passkeys wallet popup. Please open it to continue.',
  acceptText: 'Open',
} satisfies ConfirmRequestData;

export const PRIVATE_BROWSING_MESSAGE = {
  title: 'Turn off private browsing',
  message:
    'Passkeys don’t support private browsing in Safari. Turn off to continue.',
  icon: 'private',
} satisfies NotifyRequestData;

export const ALLOWED_ORIGINS = [
  __PASSKEYS_NETWORK_URL__,
  window.location.origin, // This is required for the open popup modal.
  ...(__STANDALONE_MODE__ ? [] : [new URL(document.referrer).origin]),
] as const;
